import { isRequired, isRequiredNo, isValidFaxNumber, isValidPassword, isPositiveNumberOnly, isValidEmail, isValidPhone, isValidUrl, isAlphaNumeric, isValidDate, isValidConversionRate, isValidFileSize, isTextOnly, isNumberOnly, isValidString } from '../utils/Validate';
import { ValidateMessages } from '../constants/ValidateConstants';
import { ValidateName } from '../constants/ValidateNameConstants'

export default function validateField(value, field, message, validationTypes = [], validator = undefined, existingItems = [], id = null) {
  const checkDuplicate = (values, customerData) => {
    return customerData?.some((obj) => obj?.email === values?.email);
  };

  const errors = [];

  validationTypes.forEach(validationType => {
    switch (validationType) {
      case ValidateName?.REQUIRED:
        if (!isRequired(value)) {
          errors.push(ValidateMessages.REQUIRED(message));
        }
        break;

      case ValidateName?.ISREQUIRED_NO:
        if (!isRequiredNo(value)) {
          errors.push(ValidateMessages.SELECTED(message));
        }
        break;

      case ValidateName?.ISVALID_DATE:
        if (isRequired(value) && !isValidDate(value)) {
          errors.push(ValidateMessages.REQUIRED(message));
        }
        break;

      case ValidateName?.ISVALID_FAX:
        if (isRequired(value) && !isValidFaxNumber(value)) {
          errors.push(ValidateMessages.NOT_VALID(field));
        }
        break;
      case ValidateName?.SHOULD_STRING:
        if (isRequired(value) && !isValidString(value)) {
          errors.push(ValidateMessages?.SHOULD_STRING(field));
        }
        break;

      case ValidateName?.ISTEXTONLY:
        if (isRequired(value) && !isTextOnly(value)) {
          errors.push(ValidateMessages?.SHOULD_STRING(field));
        }
        break;

      case ValidateName?.SHOULD_MAX_LETTER:
        if (value?.length > 5) {
          errors.push(ValidateMessages.SHOULD_MAX_LETTER(field, "five"));
        }
        break;
      case ValidateName?.ISVALID_EMAIL:
        if (isRequired(value) && !isValidEmail(value)) {
          errors.push(ValidateMessages.VALID(field));
        }
        break;
      case ValidateName?.ISVALID_URL:
        if (isRequired(value) && !isValidUrl(value)) {
          errors.push(ValidateMessages.NOT_VALID(field));
        }
        break;
      case ValidateName?.ISVALID_PHONE:
        if (isRequired(value) && !isValidPhone(value)) {
          errors.push(ValidateMessages.VALID(field));
        }
        break;

      case ValidateName?.ISVALID_CONVERSION_RATE:
        if (!isValidConversionRate(value)) {
          errors.push(ValidateMessages.NOT_ALLOWED);
        }
        break;

      case ValidateName?.ISVALID_PHONE:
        if (isRequired(value)) {
          errors.push(ValidateMessages.VALID(field));
        }
        break;
      case ValidateName?.NOT_VALID:
        if (validator && !validator(value)) {
          errors.push(ValidateMessages.NOT_VALID(field));
        }
        break;
      case ValidateName?.MIN_LENGTH:
        if (isRequired(value) && value.length < 3) {
          errors.push(ValidateMessages.MIN_LENGTH("3"));
        }
        break;

      case ValidateName?.ISNUMBERONLY:
        if (isRequired(value) && !isNumberOnly(value)) {
          errors.push(ValidateMessages?.DIGITS_ALLOWED);
        }
        break;
      case ValidateName?.ISPOSITIVENUMBER:
        if (isRequired(value) && !isPositiveNumberOnly(value)) {
          errors.push(ValidateMessages?.POSITIVE_NUMBER_ALLOWED);
        }
        break;
      case ValidateName?.DUPLICATE_EMAIL:
        if (isValidEmail(value) && checkDuplicate({ email: value }, existingItems)) {
          errors.push(ValidateMessages.EMAIL_ALREADY_EXISTS);
        }
        break;
      case ValidateName?.VALID_FILE_SIZE:
        if (isRequired(value) && isValidFileSize(value)) {
          errors.push(ValidateMessages.FILE_SIZE("Image", "500"));
        }
        break;
      case ValidateName?.UNIQUE_ITEMS:
        if (!isRequiredNo(value) || existingItems.some(item => item === value && item.id !== id)) {
          errors.push(ValidateMessages.REQUIRED(message));
          errors.push(ValidateMessages.ALREADY_EXISTS);
        }
        break;
      case ValidateName?.USERPASSWORD:
        if (isRequired(value) && !isValidPassword(value)) {
          errors.push(ValidateMessages.PASSWORD_RESTRICTION);
        }
        break;
      case ValidateName?.UNIQUE_CONTACTS:
        if (existingItems.some(item => item.email === value.email &&
          item.phone === value.phone &&
          item.id !== value.id)) {
          errors.push(ValidateMessages.CONTACT_AVAILABLE);
        }
        break;

      default:
        if (typeof validationType === 'function') {
          const customError = validationType(value);
          if (customError) {
            errors.push(customError);
          }
        }

        break;
    }
  });

  return errors.length > 0 ? errors[0] : undefined;
}
